import HomeBanner from "../assets/images/Home/Banner_Background.webp";
import HomeBannerChild from "../assets/images/Home/Banner_Child.webp";
import HomeCIA from "../assets/images/Home/CIA.webp";
import HomeDatabase from "../assets/images/Home/Database.webp";
import HomeMethods from "../assets/images/Home/Methods.png";
import searchIcon from "../assets/images/Header/grey_search.png";
import WiaLogo from "../assets/images/Header/WIA1.webp";
import BagchiLogo from "../assets/images/Header/Bagchi_Logo.webp";
import AboutUs_Polygon from "../assets/images/Home/Polygon-1.webp";
import Initiatives_Polygon1 from "../assets/images/Home/Polygon.webp";
import EvolveLogo from "../assets/images/Footer/evolve.png";
import Facebook from "../assets/images/Footer/Facebook.png";
import Twitter from "../assets/images/Footer/Twitter.png";
import Youtube from "../assets/images/Footer/Youtube.png";

// Common Icons (reusable across pages)
import IconEmail from "../assets/images/common/Email.png";
import IconName from "../assets/images/common/Name.png";
import IconPhone from "../assets/images/common/Call.png";
import IconPortfolio from "../assets/images/common/Portfolio.png";
import IconPassword from "../assets/images/common/Password.png";
import IconDropdown from "../assets/images/common/Drop-Down.png";
import IconHelpSection from "../assets/images/common/Help_Section.png";
import IconUserProfile from "../assets/images/Profile/User-Profile.png";
import IconEdit from "../assets/images/common/Edit_Icon.png";
import IconSuccess from "../assets/images/common/Success.png";
import IconError from "../assets/images/common/Error.png";
import IconWarning from "../assets/images/common/Warning.png";
import IconNotFound from "../assets/images/common/Not_Found.png";
import IconServerError from "../assets/images/common/Server_Error.png";
import IconUnauthorized from "../assets/images/common/Unauthorized.png";

// Backgrounds
import SignupBg from "../assets/images/Signup/Signup-Bg.webp";
import LoginBg from "../assets/images/Login/Login-bg.webp";
import ForgotPwdBg from "../assets/images/Forgot-Password/ForgotPwd-bg.webp";
import ProfileBg from "../assets/images/Profile/Profile_bg.webp";
import ResetPwdBg from "../assets/images/Reset-Password/ResetPwd-Bg.webp";
import ChangePwdBg from "../assets/images/Change-Password/ChangePwd-bg.webp";

//Password Icons
import passwordIcon from "../assets/images/Change-Password/Password.png";
import eyeIcon from "../assets/images/Change-Password/eye.png";
import eyeHideIcon from "../assets/images/Change-Password/eye-off.png";

//Data Visualization Icons
import BarChartIcon from "../assets/images/Data_Visualization/bar-chart.png";
import PieChartIcon from "../assets/images/Data_Visualization/pie-chart.png";
import SunburstChartIcon from "../assets/images/Data_Visualization/sunburst-chart.svg";
import TableIcon from "../assets/images/Data_Visualization/table.png";

//Factsheet
import Factsheet_Chart from "../assets/images/Factsheets/Factsheet_Chart.png";

//Help Screenshots
import getting_started_img1 from "../assets/images/Getting-Started/Getting start- 1.webp";
import getting_started_img2 from "../assets/images/Getting-Started/Getting start- 2.webp";
import getting_started_img3 from "../assets/images/Getting-Started/Getting start- 3.webp";
import signup_process_img1 from "../assets/images/Signup/Signup- 1.webp";
import signup_process_img2 from "../assets/images/Signup/Signup- 2.webp";
import signup_process_img3 from "../assets/images/Signup/Signup- 3.webp";
import signup_process_img4 from "../assets/images/Signup/Signup- 4.webp";
import signup_process_img5 from "../assets/images/Signup/Signup- 5.webp";
import signup_process_img6 from "../assets/images/Signup/Signup- 6.webp";
import login_process_img1 from "../assets/images/Login/Login- 1.webp";
import login_process_img2 from "../assets/images/Login/Login- 2.webp";
import login_process_img3 from "../assets/images/Login/Login- 3.webp";
import change_password_img1 from "../assets/images/Change-Password/Change- 1.webp";
import change_password_img2 from "../assets/images/Change-Password/Change- 2.webp";
import change_password_img3 from "../assets/images/Change-Password/Change- 3.webp";
import forgot_password_img1 from "../assets/images/Forgot-Password/Forgot- 1.webp";
import forgot_password_img2 from "../assets/images/Forgot-Password/Forgot- 2.webp";
import forgot_password_img3 from "../assets/images/Forgot-Password/Forgot- 3.webp";
import forgot_password_img4 from "../assets/images/Forgot-Password/Forgot- 4.webp";
import forgot_password_img5 from "../assets/images/Forgot-Password/Forgot- 5.webp";
import profile_img1 from "../assets/images/Profile/Profile- 1.webp";
import profile_img2 from "../assets/images/Profile/Profile- 2.webp";
import logout_img1 from "../assets/images/Logout/Logout- 1.webp";
import logout_img2 from "../assets/images/Logout/Logout-2.webp";
import home_page_img1 from "../assets/images/Home/Home- 1.webp";
import home_page_img2 from "../assets/images/Home/Home- 2.webp";
import home_page_img3 from "../assets/images/Home/Home- 3.webp";
import home_page_img4 from "../assets/images/Home/Home- 4.webp";
import factsheet_img1 from "../assets/images/Factsheets/Factsheet- 1.webp";
import factsheet_img2 from "../assets/images/Factsheets/Factsheet- 2.webp";
import data_viz_img1 from "../assets/images/Data_Visualization/DV-1.webp";
import data_viz_img2 from "../assets/images/Data_Visualization/DV-2.webp";
import data_viz_img3 from "../assets/images/Data_Visualization/DV-3.webp";
import data_viz_img4 from "../assets/images/Data_Visualization/DV-4.webp";
import footer_img1 from "../assets/images/Footer/Footer-1.webp";

export const IMAGES = {
  HOME: {
    BANNER: HomeBanner,
    BANNER_CHILD: HomeBannerChild,
    CIA: HomeCIA,
    DATABASE: HomeDatabase,
    METHODS: HomeMethods,
    ABOUT_US: AboutUs_Polygon,
    INITIATIVES: Initiatives_Polygon1,
  },
  HEADER: {
    WIA_LOGO: WiaLogo,
    BAGCHI_LOGO: BagchiLogo,
    SEARCH_ICON: searchIcon,
  },
  FOOTER: {
    FACEBOOK: Facebook,
    TWITTER: Twitter,
    YOUTUBE: Youtube,
    EVOLVE_LOGO: EvolveLogo,
  },
  // Centralized reusable icons
  ICONS: {
    EMAIL: IconEmail,
    NAME: IconName,
    PHONE: IconPhone,
    PORTFOLIO: IconPortfolio,
    PASSWORD: IconPassword,
    DROPDOWN: IconDropdown,
    DESCRIPTION: IconPortfolio, // Reusing portfolio icon for description
    HELP_SECTION: IconHelpSection,
    EDIT: IconEdit,
    SUCCESS: IconSuccess,
    ERROR: IconError,
    WARNING: IconWarning,
    NOT_FOUND: IconNotFound,
    SERVER_ERROR: IconServerError,
    UNAUTHORIZED: IconUnauthorized,
  },
  // Page backgrounds only
  AUTH: {
    SIGNUP_BG: SignupBg,
    LOGIN_BG: LoginBg,
    FORGOT_PASSWORD_BG: ForgotPwdBg,
    RESET_PASSWORD_BG: ResetPwdBg,
    BACKGROUND: ChangePwdBg,
  },
  PROFILE: {
    BACKGROUND: ProfileBg,
    DESCRIPTION: IconPortfolio,
    USER_PROFILE: IconUserProfile,
  },
  CHANGEPASSWORD: {
    PASSWORD_ICON: passwordIcon,
    EYE_ICON: eyeIcon,
    EYE_HIDE_ICON: eyeHideIcon,
  },
  DATA_VISUALIZATION: {
    BAR_CHART: BarChartIcon,
    PIE_CHART: PieChartIcon,
    SUNBURST_CHART: SunburstChartIcon,
    TABLE: TableIcon,
  },
  HELP: {
    GETTING_STARTED_IMG1: getting_started_img1,
    GETTING_STARTED_IMG2: getting_started_img2,
    GETTING_STARTED_IMG3: getting_started_img3,
    SIGNUP_IMG1: signup_process_img1,
    SIGNUP_IMG2: signup_process_img2,
    SIGNUP_IMG3: signup_process_img3,
    SIGNUP_IMG4: signup_process_img4,
    SIGNUP_IMG5: signup_process_img5,
    SIGNUP_IMG6: signup_process_img6,
    LOGIN_IMG1: login_process_img1,
    LOGIN_IMG2: login_process_img2,
    LOGIN_IMG3: login_process_img3,
    CHANGE_PASSWORD_IMG1: change_password_img1,
    CHANGE_PASSWORD_IMG2: change_password_img2,
    CHANGE_PASSWORD_IMG3: change_password_img3,
    FORGOT_PASSWORD_IMG1: forgot_password_img1,
    FORGOT_PASSWORD_IMG2: forgot_password_img2,
    FORGOT_PASSWORD_IMG3: forgot_password_img3,
    FORGOT_PASSWORD_IMG4: forgot_password_img4,
    FORGOT_PASSWORD_IMG5: forgot_password_img5,
    PROFILE_IMG1: profile_img1,
    PROFILE_IMG2: profile_img2,
    LOGOUT_IMG1: logout_img1,
    LOGOUT_IMG2: logout_img2,
    HOME_PAGE_IMG1: home_page_img1,
    HOME_PAGE_IMG2: home_page_img2,
    HOME_PAGE_IMG3: home_page_img3,
    HOME_PAGE_IMG4: home_page_img4,
    FACTSHEET_IMG1: factsheet_img1,
    FACTSHEET_IMG2: factsheet_img2,
    DATA_VIZ_IMG1: data_viz_img1,
    DATA_VIZ_IMG2: data_viz_img2,
    DATA_VIZ_IMG3: data_viz_img3,
    DATA_VIZ_IMG4: data_viz_img4,
    FOOTER_IMG1: footer_img1,
  },
  FACTSHEET: {
    FACTSHEET: Factsheet_Chart,
  },
};
